import { initialState } from "./reducers"

export const select = (state) => state || initialState

export const selectSocialQuestState = (state) =>
    select(state).socialQuest?.socialQuestState
